<div class="pb-2 mb-3">
  <h3>
    <b>Encryption keys</b>
  </h3>
</div>
<div *ngIf="noKeys" class="alert alert-danger alert-dismissible fade show">
  No available data !
</div>
<div *ngIf="notFoundKeys" class="alert alert-danger alert-dismissible fade show">
  Keys not found !
  <button (click)="notFoundKeys = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div style="display: flex;">
  <div *ngIf="!noKeys" style="width: 75%; ">
    <p-table (sortFunction)="tableService.customSort($event)" [columns]="columns" [customSort]="true"
             [value]="encryptionKeysInfo" id="prod_encryption_keys_logs">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumnDisabled]="col.sortDisabled" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon *ngIf="!col.sortDisabled" [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelAsc="Activate to sort in ascending order"
                        ariaLabelDesc="Activate to sort in descending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template [ngForOf]="encryptionKeysInfo" let-key ngFor pTemplate="body">
        <tr>
          <td>{{key.pop}}</td>
          <td>{{key.channel}}</td>
          <td>{{key.products}}</td>
          <td>{{key.protected ? 'Yes' : 'No' }}</td>
          <td>{{getWeek1(key)}}</td>
          <td>{{getWeek2(key)}}</td>
          <td>{{getWeek3(key)}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div style="flex: 1">
    <button (click)="downloadAvailableEncryptionKeys()" [disabled]="encryptionKeysInfo?.length <= 0" icon="fa fa-download pr-2" iconPos="left"
            id="download_past_file_with_multi_date_button" label="Download available keys"
            pButton style="margin-left: 40px; float:left"
            type="button"></button>
  </div>
</div>

